import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { appConfig } from "../config"
import keycloak from "../keycloak"

import {
  fetchWarehouseOptionsSuccess,
  fetchInspectionsSuccess,
  fetchInspectionSuccess,
  updateInspectionSuccess,
  searchConsignerProductsSuccess,
  fetchConsignerProductSuccess,
  fetchWarehouserOptionsSuccess,
  fetchWarehousesForWarehouserOptionsSuccess,
  saveItemSuccess
} from "../actions/Inspections";

import {
  FETCH_WAREHOUSE_OPTIONS,
  FETCH_INSPECTIONS,
  FETCH_INSPECTION,
  UPDATE_INSPECTION,
  SEARCH_CONSIGNER_PRODUCTS, 
  FETCH_CONSIGNER_PRODUCT,
  FETCH_WAREHOUSER_OPTIONS,
  FETCH_WAREHOUSER_WAREHOUSE_OPTIONS,
  SAVE_ITEM
} from "../constants/ActionTypes";

const baseUrl = appConfig.baseApiUrl

const withHeaders = async (block) => {
  return await keycloak.updateToken(20).then(() => {
    return block({
      'Authorization': 'Bearer ' + keycloak.token,
      'Csrf-Token': 'nocheck-allow',
      'Content-Type': 'application/json'
      })
    });
}

const getWarehouseOptions = async () => {
  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inspector/warehouses", { headers:  headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const getInspections = async (data) => {

  const params = data.payload;
  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inspections", { headers:  headers, params: params })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })


}

const getInspection = async (data) => {
  // Get id
  let id = data.payload;

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inspections/" + id, {headers: headers})
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const updateInspection = async (data) => {
  let inspection = data.payload;
  let id = inspection.id;

  return await withHeaders((headers) => {
    return axios.put(baseUrl + "/api/inspections/"+id, inspection, { headers:  headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const getWarehousers = async (data) => {

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/organizations/warehousers", { headers:  headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })


}

const getWarehouserWarehouses = async (data) => {

  const params = data.payload;
  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/warehouses", { headers:  headers, params: params })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })


}

const getProducts = async (data) => {

  const params = data.payload;
  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/catalog/products", { headers:  headers, params: params })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })

}

const getProduct = async (data) => {

  const id = data.payload;
  return await withHeaders((headers) => {
    return axios.get(baseUrl + `/api/catalog/products/${id}`, { headers:  headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })

}
const saveItem = async (data) => {
  let item = data.payload;

  return await withHeaders((headers) => {
    return axios.post(baseUrl + "/api/inspections", item, { headers:  headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}


function* fetchWarehouseOptionsRequest(data) {
  try {
    const fetched = yield call(getWarehouseOptions, data);
    yield put(fetchWarehouseOptionsSuccess(fetched));
  } catch (error) {
    console.log("fetchWarehouseOptionsRequest Error:", error);
  }
}

function* fetchInspectionsRequest(data) {
  try {
    const fetched = yield call(getInspections, data);
    yield put(fetchInspectionsSuccess(fetched));
  } catch (error) {
    console.log("fetchInspectionsRequest Error:", error);
  }
}

function* fetchProductsRequest(data) {
  try {
    const fetched = yield call(getProducts, data);
    yield put(searchConsignerProductsSuccess(fetched));
  } catch (error) {
    console.log("fetchProductsRequest Error:", error);
  }
}

function* fetchProductRequest(data) {
  try {
    const fetched = yield call(getProduct, data);
    yield put(fetchConsignerProductSuccess(fetched));
  } catch (error) {
    console.log("fetchProductRequest Error:", error);
  }
}

function* fetchWarehousersRequest() {
  try {
    const fetched = yield call(getWarehousers);
    yield put(fetchWarehouserOptionsSuccess(fetched));
  } catch (error) {
    console.log("fetchWarehousersRequest Error:", error);
  }
}

function* fetchWarehouserWarehousesRequest(data) {
  try {
    const fetched = yield call(getWarehouserWarehouses, data);
    yield put(fetchWarehousesForWarehouserOptionsSuccess(fetched));
  } catch (error) {
    console.log("fetchWarehouserWarehousesRequest Error:", error);
  }
}

function* fetchInspectionRequest(data) {
  try {
    const fetched = yield call(getInspection, data);
    yield put(fetchInspectionSuccess(fetched));
  } catch (error) {
    console.log("fetchInspectionRequest Error:", error);
  }
}

function* updateInspectionRequest(data) {
  try {
    const updatedEntity = yield call(updateInspection, data);
    yield put(updateInspectionSuccess(updatedEntity));
  } catch (error) {
    console.log("updateInspectionRequest Error:", error);
  }
}

function* saveItemRequest(data) {
  try {
    const updatedEntity = yield call(saveItem, data);
    yield put(saveItemSuccess(updatedEntity));
  } catch (error) {
    console.log("saveItemRequest Error:", error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(SEARCH_CONSIGNER_PRODUCTS, fetchProductsRequest),
    takeEvery(FETCH_CONSIGNER_PRODUCT, fetchProductRequest),
    takeEvery(FETCH_WAREHOUSE_OPTIONS, fetchWarehouseOptionsRequest),
    takeEvery(FETCH_INSPECTIONS, fetchInspectionsRequest),
    takeEvery(FETCH_INSPECTION, fetchInspectionRequest),
    takeEvery(UPDATE_INSPECTION, updateInspectionRequest),
    takeEvery(SAVE_ITEM, saveItemRequest),
    takeEvery(FETCH_WAREHOUSER_OPTIONS, fetchWarehousersRequest),
    takeEvery(FETCH_WAREHOUSER_WAREHOUSE_OPTIONS, fetchWarehouserWarehousesRequest)
  ]);
}
